import { DocumentData, limit, onSnapshot, orderBy, query, QuerySnapshot, where, startAt, Timestamp, DocumentSnapshot, Query, getDocs } from "firebase/firestore";
import { DataAccessService } from "./basic.service";
import { getDownloadURL, getStorage, ref as storageRef } from "firebase/storage";
import { errorSnapshotFunctionCallback, nextSnapshotFunctionCallback } from "@/types/firebase";
import moment from "moment";

class TabletScreenshotsDAService extends DataAccessService {

    constructor(collectionName: string) {
        super(collectionName)
    }

    preRender(querySnapshot: QuerySnapshot<DocumentData>) {
        const screenshots: any = []
            querySnapshot.forEach(doc => {
                screenshots.push(doc.data())
            })

        return new Promise((resolve) => {
            Promise.all([
                Promise.all(screenshots.map((screenshot: any) => getDownloadURL(storageRef(getStorage(), screenshot.ImageUrl)))),
            ]).then((d: any) => {
                resolve(screenshots.map((item: any, idx: number) => {
                    item.FileUrl = d[0][idx]
                    item.MDate = moment.unix(item.createdAt / 1000).format('DD/MM/YY H:mm:ss')
                    return item
                }))
            }).catch(err => {
                console.error(err)
                resolve([])
            })
        })
    }

    getByDeviceId(deviceId: string, size: number, lastSeen: DocumentSnapshot | null, beforeTheTime: Timestamp|number, afterTheTime: Timestamp|number,  onResult: CallableFunction) 
    {
        getDocs(this.getQueryByDevice(parseInt(deviceId), size, lastSeen, beforeTheTime, afterTheTime))
        .then((querySnapshot: QuerySnapshot<DocumentData>) => {
                this.preRender(querySnapshot).then(data =>{
                    onResult(data)
                }).catch(err => {
                    console.error(err)
                    onResult([])
                })
            }
        );
    }

    getQueryByDevice(deviceId: number, size: number, lastSeen: DocumentSnapshot | null = null, beforeTheTime: Timestamp|number = 0, afterTheTime: Timestamp|number = 0) {
        
        const args = [ where('deviceId', '==', deviceId)]

        if (beforeTheTime != 0) {
            args.push(where('createdAt', '<=', beforeTheTime)) 
        }
        if (afterTheTime != 0) {
            args.push(where('createdAt', '>=', afterTheTime))
        }
        if (lastSeen != null) {
            args.push(startAt(lastSeen))
        }
        
        args.splice(args.length-1, 0, orderBy('createdAt', 'desc'), limit(size))

        return query(this.getCollection(), ...args)
    }

    getQuery(size: number, lastSeen: DocumentSnapshot | null = null, beforeTheTime: Timestamp|number = 0, afterTheTime: Timestamp|number = 0) {
        
        const args = [ ]
        
        if (beforeTheTime != 0) {
            args.push(where('createdAt', '<=', beforeTheTime)) 
        }
        if (afterTheTime != 0) {
            args.push(where('createdAt', '>=', afterTheTime))
        }
        if (lastSeen != null) {
            args.push(startAt(lastSeen))
        }
        
        args.splice(args.length-1, 0, orderBy('createdAt', 'desc'), limit(size))

        return query(this.getCollection(), ...args)
    }
    
    getSnaphostCollectionByQuery(query: Query<DocumentData>, onNext: nextSnapshotFunctionCallback, 
        onError: errorSnapshotFunctionCallback, 
        onComplete: () => void) {
        return onSnapshot(query, onNext, onError, onComplete)
    }
}
export default new TabletScreenshotsDAService('tablet_screenshots');